export default __webpack_public_path__ + "static/media/ScopeBox.d3cb78b8.svg";